import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useRfmGroupList } from '@/modules/rfm/group/model/list';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';
import { rfmService } from '@/services/rfm';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useRfmRecency() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { rfmGroupOptions, fetchRfmGroupAll } = useRfmGroupList();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        fromDay: 0,
        groupId: StringUtils.toNumber(route.query.groupId?.toString())
    });

    const validations = {
        fromDay: { required, numeric, minValue: minValue(0) },
        groupId: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.id != null,
        request: () => rfmService.recency.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_RFM.RECENCY.INDEX, query: { groupId: model.groupId } })
    });

    const actions = {
        create: crudAction.confirmAndExecute({
            validator: v$,
            request: () => rfmService.recency.create(model.fromDay, model.groupId),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.RECENCY.INDEX, query: { groupId: model.groupId } })
        }),

        update: crudAction.confirmAndExecute({
            validator: v$,
            request: () => rfmService.recency.update(model.id, model.fromDay),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.RECENCY.INDEX, query: { groupId: model.groupId } })
        }),

        remove: crudAction.confirmAndRemove({
            request: () => rfmService.recency.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.RECENCY.INDEX, query: { groupId: model.groupId } })
        })
    };

    return { model, v$, fetch, rfmGroupOptions, fetchRfmGroupAll, actions };
}
